<template>
  <div class="wrapper contact">
    <div class="list box-padding">
      <div class="row" style="padding: 0">
        <div class="col-sm-6 col-xs-12">
          <div class="row">
            <div class="col-sm-4 col-xs-12  side-column">
              <h3>CENTRE<span>SHANGHAI.CHINA </span></h3>
              <h4 style="font-weight: 600">中国·上海 总部</h4>
            </div>
            <div class="col-sm-8 col-xs-12  info">
              <h4>{{ $t('pages.contact[0].address_title') }}</h4>
              <span v-html="$t('pages.contact[0].address_content')"></span>
              <h4>{{ $t('pages.contact[0].business_title') }}</h4>
              <span v-html="$t('pages.contact[0].business_content')"></span>
            </div>
            <div class="col-sm-7 col-xs-12 col-sm-offset-4 col-md-6 col-md-offset-4 col-lg-6 col-lg-offset-4  info map" id="map-shanghai"></div>
          </div>
        </div>
        <div class="col-sm-6 col-xs-12">
          <div class="row">
            <div class="col-sm-4 col-xs-12 side-column">
              <h3><span>GUANGZHOU.CHINA</span></h3>
              <h4 style="font-weight: 600">中国·广州 分部</h4>
            </div>
            <div class="col-sm-8 col-xs-12 info">
              <h4>{{$t('pages.contact[1].address_title')}}</h4>
              <span v-html="$t('pages.contact[1].address_content') "></span>

              <h4>{{$t('pages.contact[1].phone_title')}}</h4>
              <span v-html="$t('pages.contact[1].phone_content') "></span>

              <h4>{{$t('pages.contact[1].business_title')}}</h4>
             <span v-html="$t('pages.contact[1].business_content')"></span>
            </div>
            <div class="col-sm-7 col-xs-12 col-sm-offset-4 col-md-6 col-md-offset-4 col-lg-6 col-lg-offset-4  info map" id="map-guangzhou"></div>
          </div>
        </div>
      </div>
      <div class="row" style="padding-bottom: 0">
        <div class="col-sm-6 col-xs-12">
          <div class="row">
            <div class="col-sm-4 col-xs-12 side-column">
              <h3>GLOBAL CREATIVE HUB.<span>CHINA</span></h3>
              <h4 style="font-weight: 600">国际创意资源</h4>
            </div>
            <div class="col-sm-8 col-xs-12 info">
              <h4>{{$t('pages.contact[2].business_title')}}</h4>
              <span v-html="$t('pages.contact[2].business_content')"></span>
            </div>
          </div>
        </div>
        <div class="col-sm-6 col-xs-12">
          <div class="row">
            <div class="col-sm-4 col-xs-12 side-column">
              <h3>SUPPLY CHAIN.<span>CHINA</span></h3>
              <h4 style="font-weight: 600">整合供应链</h4>
            </div>
            <div class="col-sm-8 col-xs-12 info">
              <h4>{{$t('pages.contact[3].business_title')}}</h4>
              <span v-html="$t('pages.contact[3].business_content')"></span>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6 col-xs-12">
          <div class="row">
            <div class="col-sm-4 col-xs-12 side-column">
              <h3>R&D CENTRE KOBE.<span>JAPAN</span></h3>
              <h4 style="font-weight: 600">日本·神户 研发中心</h4>
            </div>
            <div class="col-sm-8 col-xs-12 info">
              <h4>{{$t('pages.contact[4].address_title')}}</h4>
              <span v-html="$t('pages.contact[4].address_content')"></span>

              <h4>{{$t('pages.contact[4].business_title')}}</h4>
              <span v-html="$t('pages.contact[4].business_content')"></span>
            </div>
            <!--<div class="col-sm-6 col-xs-12 map" id="map-shenhu"></div>-->
          </div>
        </div>
        <div class="col-sm-6 col-xs-12">
          <div class="row">
            <div class="col-sm-4 col-xs-12 side-column">
              <h3>HUMAN RESOURCES.<span>CHINA</span></h3>
              <h4 style="font-weight: 600">人力资源部</h4>
            </div>
            <div class="col-sm-8 col-xs-12 info">
              <h4>{{$t('pages.contact[5].recruitment_title')}}</h4>
             <span v-html="$t('pages.contact[5].recruitment_content')"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import mapManager from '@/utils/map_manager';

  export default {
    data() {
      return {
        contactList: [{
        }],
      };
    },
    mounted() {
      const self = this;
      if (window.BMap && window.BMap.Map) {
        this.initMap(window.BMap);
      } else {
        window.onload = function () {
          self.initMap(window.BMap);
        };
      }
    },
    methods: {
      initMap(BMap) {
        mapManager.setAk('rYCKmvW4fAmb1usg3G7YT8nyPmrqrMpy');
        // mapManager.getMapInstance().then((BMap) => {
        const level = 15;
        const map1 = new BMap.Map('map-shanghai');    // 创建Map实例
        // map1.centerAndZoom(new BMap.Point(121.502788, 31.207219), level);  // 初始化地图,设置中心点坐标和地图级别
        map1.centerAndZoom(new BMap.Point(121.490002, 31.207744), level);  // 初始化地图,设置中心点坐标和地图级别
        map1.addControl(new BMap.MapTypeControl());   // 添加地图类型控件
        map1.setCurrentCity('上海');          // 设置地图显示的城市 此项是必须设置的
        const myGeo1 = new BMap.Geocoder();
        myGeo1.getPoint('上海黄浦区瞿溪路691号宏欣科技设计创意园一楼群108、110室', (point) => {
          if (point) {
            map1.centerAndZoom(point, 16);
            map1.addOverlay(new BMap.Marker(point));
          } else {
            alert('您选择地址没有解析到结果!');
          }
        }, '上海市');
        const map2 = new BMap.Map('map-guangzhou');    // 创建Map实例
        map2.centerAndZoom(new BMap.Point(113.333566, 23.127401), level);  // 初始化地图,设置中心点坐标和地图级别
        map2.addControl(new BMap.MapTypeControl());   // 添加地图类型控件
        map2.setCurrentCity('广州');          // 设置地图显示的城市 此项是必须设置的
        const myGeo2 = new BMap.Geocoder();
        // 将地址解析结果显示在地图上,并调整地图视野
        myGeo2.getPoint('广州市天河区珠江新城洗村路11号保利威座2005-2006', (point) => {
          if (point) {
            map2.centerAndZoom(point, 16);
            map2.addOverlay(new BMap.Marker(point));
          } else {
            alert('您选择地址没有解析到结果!');
          }
        }, '广州市');
      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/pages/contact/contact.vue